import { useEffect, useState } from "react";
import { Users, CreditCard, UserPlus, UserMinus, Activity, BookOpen, Puzzle } from "lucide-react";
import api from "@/lib/api";

const CARDS = [
  { key: "students", label: "Alunos cadastrados", icon: Users },
  { key: "active_subscribers", label: "Assinantes ativos", icon: CreditCard, gold: true },
  { key: "new_subscribers", label: "Novos assinantes", icon: UserPlus },
  { key: "cancellations", label: "Cancelamentos", icon: UserMinus },
  { key: "studying_today", label: "Alunos estudando hoje", icon: Activity },
  { key: "lessons_completed", label: "Aulas concluídas", icon: BookOpen },
  { key: "puzzles_solved", label: "Puzzles resolvidos", icon: Puzzle },
];

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(({ data }) => setData(data)).catch(() => {}); }, []);

  return (
    <div className="p-5 sm:p-8">
      <h1 className="font-heading text-3xl text-chessup-text mb-1">Visão Geral</h1>
      <p className="text-chessup-subtext text-sm mb-8">Dados reais da ChessUp Academy.</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="rounded-xl border border-chessup-border bg-chessup-card p-5" data-testid={`admin-card-${c.key}`}>
              <div className={`h-9 w-9 rounded-lg flex items-center justify-center mb-3 ${c.gold ? "bg-chessup-gold/12 text-chessup-goldlight" : "bg-chessup-turq/12 text-chessup-turq"}`}><Icon style={{ width: 18, height: 18 }} /></div>
              <div className="text-3xl font-bold text-chessup-text">{data ? data[c.key] ?? 0 : "—"}</div>
              <div className="text-xs text-chessup-subtext mt-1">{c.label}</div>
            </div>
          );
        })}
      </div>
      <div className="mt-8 rounded-xl border border-chessup-border bg-chessup-deep/40 p-5 text-sm text-chessup-subtext">
        Métricas financeiras avançadas (MRR, Churn, LTV, conversão) serão exibidas aqui conforme os dados reais forem acumulando.
      </div>
    </div>
  );
}
